import aboutImg from '@assets/img/about.webp';

const AboutSection = () => {
    return (
        <section className="sec sec-about" id="about">
            <div className="about__content">
                <div className="about__content-wrap">
                    <h2 className="about__title">About</h2>
                    <p className="about__description">
                        NCV GAMES is dedicated to building bridges across the world through gaming. We create unique experiences that
                        inspire, entertain, and bring players together, cultivating a global community where everyone can belong, explore,
                        and grow.
                        <br />
                        <br />
                        We design unique, immersive worlds that captivate imagination, fostering a global community of gamers united by a
                        shared passion for play.
                        <br />
                        At NCV GAMES, we are dedicated to pushing the boundaries of gaming, continuously innovating to create unforgettable
                        adventures for everyone.
                    </p>
                </div>
                <div className="about__image">
                    <img src={aboutImg} alt="NCSOFT and VNG Games Signing Ceremony" className="about__img" />
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
